import type { HashtagListResponsePageAllOf } from './hashtagListResponsePageAllOf';
import type { HashtagListResponsePageAllOfThree } from './hashtagListResponsePageAllOfThree';

export type HashtagListResponsePage = HashtagListResponsePageAllOf & HashtagListResponsePageAllOfThree;
